import { render, staticRenderFns } from "./newsg.vue?vue&type=template&id=ab31090e&scoped=true"
import script from "./newsg.vue?vue&type=script&lang=js"
export * from "./newsg.vue?vue&type=script&lang=js"
import style0 from "./newsg.vue?vue&type=style&index=0&id=ab31090e&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ab31090e",
  null
  
)

export default component.exports